import apiClient from './botsApiClient'
import qs from 'qs'

const botsRequest = apiClient({
    paramsSerializer: params => qs.stringify(params),
    validateStatus(status) {
        return status === 200
    }
})

export default botsRequest
